var map = {
	".": "KsRT",
	"./": "KsRT",
	"./01_executionReport": "H6dO",
	"./01_executionReport.json": "H6dO",
	"./02_ account_update": "bZVt",
	"./02_ account_update.json": "bZVt",
	"./index": "KsRT",
	"./index.js": "KsRT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ELvl";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/account ^.*$
// module id = ELvl
// module chunks = 3